
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-to-text",
      function () {
        return require("private-next-pages/video-to-text/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-to-text"])
      });
    }
  